// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigatorCode-board-game-content {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-content: center;
  width: 100%;
  height: 100%;
}
.word-search {
  display: grid;
  gap: 0;
  width: max-content;
  background: white;
  border-bottom: 0.1vw #1a6a7c solid;
  border-right: 0.1vw #1a6a7c solid;
  box-shadow:
    0 0.2vw 0.4vw rgba(0, 0, 0, 0.12),
    0 0.3vw 1vw rgba(0, 0, 0, 0.08);
}

.word-search-cell {
  width: 3vw;
  height: 3vw;

  display: flex;
  justify-content: center;
  align-items: center;
 font-family: "Amatic SC";
  border-left: 0.1vw #1a6a7c solid;
  border-top: 0.1vw #1a6a7c solid;
}
.word-search-cell {
  font-size: 1.8vw;
      font-family: "Phenoma Light";
  cursor: pointer;
}
.word-search-cell--selected {
  background:rgb(147, 224, 237);
}
`, "",{"version":3,"sources":["webpack://./src/TaskWindows/NavigatorСode/styles/Navigator%D0%A1odeBoardType1.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,MAAM;EACN,kBAAkB;EAClB,iBAAiB;EACjB,kCAAkC;EAClC,iCAAiC;EACjC;;mCAEiC;AACnC;;AAEA;EACE,UAAU;EACV,WAAW;;EAEX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;CACpB,wBAAwB;EACvB,gCAAgC;EAChC,+BAA+B;AACjC;AACA;EACE,gBAAgB;MACZ,4BAA4B;EAChC,eAAe;AACjB;AACA;EACE,6BAA6B;AAC/B","sourcesContent":[".navigatorCode-board-game-content {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-evenly;\n  align-content: center;\n  width: 100%;\n  height: 100%;\n}\n.word-search {\n  display: grid;\n  gap: 0;\n  width: max-content;\n  background: white;\n  border-bottom: 0.1vw #1a6a7c solid;\n  border-right: 0.1vw #1a6a7c solid;\n  box-shadow:\n    0 0.2vw 0.4vw rgba(0, 0, 0, 0.12),\n    0 0.3vw 1vw rgba(0, 0, 0, 0.08);\n}\n\n.word-search-cell {\n  width: 3vw;\n  height: 3vw;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n font-family: \"Amatic SC\";\n  border-left: 0.1vw #1a6a7c solid;\n  border-top: 0.1vw #1a6a7c solid;\n}\n.word-search-cell {\n  font-size: 1.8vw;\n      font-family: \"Phenoma Light\";\n  cursor: pointer;\n}\n.word-search-cell--selected {\n  background:rgb(147, 224, 237);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
